import { Fragment } from 'react';
import { ChevronRight } from 'assets/icons';

/**
 * The steps of a multi-step modal, as the design draws them: the current one
 * outlined, the ones already done tinted — and clickable, to go back — and the
 * ones ahead in grey, out of reach until reached.
 */
const StepPills = ({ steps, current, onSelect }) => {
  const currentIndex = steps.findIndex((step) => step.key === current);

  return (
    <div className="flex items-center gap-3">
      {steps.map((step, index) => {
        const done = index < currentIndex;
        const active = index === currentIndex;
        const tone = active
          ? 'bg-yellow-50 border-yellow-200 text-yellow-500'
          : done
            ? 'bg-yellow-50 border-transparent text-yellow-500 cursor-pointer hover:border-yellow-200'
            : 'bg-gray-50 border-transparent text-gray-700';

        return (
          <Fragment key={step.key}>
            {index > 0 && <ChevronRight wh={16} color="#6B7280" />}
            <button
              type="button"
              disabled={!done}
              aria-current={active ? 'step' : undefined}
              onClick={done ? () => onSelect?.(step.key) : undefined}
              className={`px-3 py-1.5 rounded-md border text-sm font-medium transition-colors ${tone}`}
            >
              {step.label}
            </button>
          </Fragment>
        );
      })}
    </div>
  );
};

export default StepPills;
